import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiSlotsService } from '../../../../services/slots/api/api-slots.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-slot-reward-add-modal',
  templateUrl: './slot-reward-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class SlotRewardAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  rewardRank: number = 0;
  multiplier: number = 0;
  rarityWeight: number = 0;
  isJackpot: boolean = false;

  private callbackSaved?: () => void;

  constructor(private apiSlotsService: ApiSlotsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.rewardRank = 0;
    this.multiplier = 0;
    this.rarityWeight = 0;
    this.isJackpot = false;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiSlotsService.addSlotReward(this.rewardRank, this.multiplier, this.rarityWeight, this.isJackpot).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Slot reward added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding slot reward : ' + error);
      }
    );
  }
}
